import React from 'react';
import { useTranslations } from '../../../../../../hooks/useTranslations';
import CheckMarkIcon from '../../../../../ui/icons/CheckMark/CheckMark';
import ControlView from '../../ControlView/ControlView';

interface MarketingSubscribedProps {
  featureName?: string;
  isLandscape: boolean;
  unsubscribing: boolean;
  marketingOptinSuccess: boolean;
  onChangeNumberClick: () => void;
  onUnsubscribeClick: () => void;
}

const MarketingSubscribed = ({
  featureName,
  isLandscape,
  marketingOptinSuccess,
  unsubscribing,
  onChangeNumberClick,
  onUnsubscribeClick,
}: MarketingSubscribedProps) => {
  const {
    notificationCenterSmsUpdateNumberMessage,
    notificationCenterSmsUpdateNumberButton,
    notificationCenterSmsOptoutLink,
  } = useTranslations();

  // Temporary translations
  const notificationCenterSublimeMarketingOptinSuccess =
    'You successfully opted in to receive updates.';

  const handlePrimaryButtonClick = () => {
    onChangeNumberClick();
  };

  const handleSecondaryButtonClick = () => {
    onUnsubscribeClick();
  };

  const heading =
    (marketingOptinSuccess
      ? notificationCenterSublimeMarketingOptinSuccess
      : notificationCenterSmsUpdateNumberMessage) ?? '';

  return (
    <ControlView
      channel="sms"
      isLandscape={isLandscape}
      featureName={featureName}
      icon={<CheckMarkIcon />}
      heading={heading}
      primaryButton={{
        text: notificationCenterSmsUpdateNumberButton ?? '',
        disabled: unsubscribing,
        onClick: handlePrimaryButtonClick,
      }}
      secondaryButton={{
        text: notificationCenterSmsOptoutLink ?? '',
        loading: unsubscribing,
        onClick: handleSecondaryButtonClick,
      }}
    />
  );
};

export default MarketingSubscribed;
